module.exports = __webpack_public_path__ + "img/four-s.e315e6bb.jpg";